import { gql } from '@apollo/client';
export const GET_ARTICLES_DATA_POSITION= gql`
mutation( $input:ArticlesPositionUpdateInput!
)
{
    updateArticlesPositions(input: $input)
{
    result
  }
    }`;